import Vue from 'vue'
import store from './store'
import localeIT from './locales/it.json'
import localeEN from './locales/en.json'
import localeES from './locales/es.json'

import './assets/css/style.css';

import App from './App.vue'
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import firebase from 'firebase/app'

import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

import VCalendar from 'v-calendar';
Vue.use(VCalendar)

import VueInputMask from "vue-inputmask";
Vue.use(VueInputMask.default)

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import Toasted from 'vue-toasted';
Vue.use(Toasted,{
    position: 'top-right',
    duration: 3000
})

Vue.config.productionTip = false

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

// localize
const moment = require('moment')
const urlParams = new URLSearchParams(window.location.search);
const language = urlParams.get('lang') || (navigator.language || navigator.userLanguage).split('-')[0];

let placeholder;
switch(language) {
    case 'it': 
        require('moment/locale/it')
        store.state.locale = 'it'
        placeholder = localeIT.steps.four.form.phone; 
        break;    
    case 'es': 
        require('moment/locale/es')
        store.state.locale = 'es'
        placeholder = localeES.steps.four.form.phone; 
        break;
    default: 
        store.state.locale = 'en'
        placeholder = localeEN.steps.four.form.phone; 
        break;
}
Vue.use(VueTelInput, {inputOptions: {placeholder }});
Vue.use(require('vue-moment'), { moment })

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: store.state.locale, // set default locale
    messages: { it: localeIT, en: localeEN, es: localeES }
})

store.dispatch('bindPlacesRefs').then( obj => {
    new Vue({
        i18n,
        store,
        router,
        render: h => h(App)
    }).$mount('#app')    
})
